const STORAGE_KEY = 'developmentexpress_booking_feedback';

export const readLocalBookingFeedbackMap = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
};

export const saveLocalBookingFeedback = (bookingId, feedback) => {
  if (!bookingId) return;
  const map = readLocalBookingFeedbackMap();
  map[String(bookingId)] = {
    ...feedback,
    submittedAt: feedback.submittedAt || new Date().toISOString(),
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
};

export const mergeBookingFeedbackFields = (booking) => {
  if (!booking?.id) return booking;
  const local = readLocalBookingFeedbackMap()[String(booking.id)];
  if (!local && !booking.client_feedback_at) return booking;
  return {
    ...booking,
    client_operator_rating: booking.client_operator_rating ?? local?.operatorRating ?? null,
    client_satisfied: booking.client_satisfied ?? local?.satisfied ?? null,
    client_suggestion: booking.client_suggestion ?? local?.suggestion ?? '',
    client_feedback_at: booking.client_feedback_at ?? local?.submittedAt ?? null,
  };
};

export const hasBookingFeedback = (booking) =>
  Boolean(
    booking?.client_feedback_at
    || booking?.client_operator_rating
    || booking?.client_satisfied != null,
  );

export const getFeedbackStatusLabel = (booking, t) => {
  if (hasBookingFeedback(booking)) {
    return `${String.fromCodePoint(0x2B50)} ${booking.client_operator_rating}/5`;
  }
  if (booking?.owner_approved) {
    return t('feedbackStatusRateNow');
  }
  return t('feedbackStatusAfterDispatch');
};
